export default __webpack_public_path__ + "static/media/expand.658de6cf.svg";